import React from "react";
import { Button, Row, Col, Glyphicon, OverlayTrigger, Tooltip } from "react-bootstrap";
import { CSVLink } from "react-csv";
import AscComponent from "../../components/AscComponent";
import ColumnFixTable from "../../containers/Elements/Table/ColumnFixTable";
import BlockUi from "react-block-ui";
import "react-block-ui/style.css";
import moment from "moment";
import * as GlobalConst from "../../components/AscConstants";
import IvrHistoryMenu from "./IvrHistoryMenu";
import IvrHistoryModal from "./IvrHistoryModal";
import CallType from "../Script/Template/CallType";

export default class IvrHistory extends AscComponent {
    constructor(props) {
        super(props);
        this.toggleBlocking = this.toggleBlocking.bind(this);

        this.state = {
            columns: [],
            data: [],
            pages: null,
            page: 0,
            pageSize: 20,
            loading: false,
            showOperatorName: false,
            filtered: [
                {
                    id: "start_datetime",
                    value: moment({h: 0, m: 0, s: 0, ms: 0})
                },
                {
                    id: "end_datetime",
                    value: moment({h: 0, m: 0, s: 0, ms: 0})
                },
                {
                    id: "start_ji",
                    value: { value: "00", label: "00" },
                },
                {
                    id: "start_hun",
                    value: { value: "00", label: "00" },
                },
                {
                    id: "end_ji",
                    value: { value: "23", label: "23" },
                },
                {
                    id: "end_hun",
                    value: { value: "59", label: "59" },
                },
            ],
            hidden_filtered: [],
            blocking: false,
            searchLimit: 10000,
            summaryTotalCalls: null,
            summaryAnsweredCalls: null,
            summaryMissedCalls: null,
            summaryAnswerRate: null,
            summaryIncomingBlockPassCount: null,
            summaryNoAnswerCount: null,
            summaryIncomingBlockAnsweredCount: null,

            // 検索メニュー
            menu_flag: false,
            menu_width: 0,
            menu_height: window.innerHeight - 100,

            // セレクトボックス
            companySelect: [],
            externalArr: [],
            display_number: [],
            extensionNumberSelect: [],
            extension_number: [],
            operatorArr: [],
            operator_name: [],
            disposition: [],
            dispositionSelect: [],
            scriptSelect: [],
            script_name: [],
            block_type: [],

            // ブロック内容表示モード: 'all'=全ブロック / 'last'=最終ブロック
            blockViewMode: 'all',

            // スクリプト詳細設定
            scriptDetailOpen: false,
            scriptVersionSelect: [],
            scriptBlockTypeSelect: [],
            scriptBlockData: {},
            enabledBlocks: {},
            blockConditionType: "and",
            blockSearchScope: "all",   // ブロック検索スコープ: "all"=全ブロック / "last"=最終ブロック

            // モーダル
            show: false,
            modalType: "",
            selectedRow: null,
            csvdata: [],
        };

        this.state.columns = this.getColumnsData();

        this.table = React.createRef();
        this.csvLink = React.createRef();
        this.blockScrollRefs = [];
        this.blockFooterRef = null;
        this.blockFooterTrackRef = null;

        this.hourShowList = this.getSelectOption("hour_show_list", this.props.langText.SelectOption);
        this.minuteShowList = this.getSelectOption("minute_show_list", this.props.langText.SelectOption);

        // 結果選択肢（PLAYBACKは除外）
        this.state.dispositionSelect = this.getSelectOption("call_result", this.props.langText.SelectOption)
            .filter(opt => opt.value !== "PLAYBACK");

    }

    async componentDidMount() {
        let canReadOperator = false;
        if (this.props.userInfo && this.props.userInfo.permission_json_data) {
            const operatorPermission = this.props.userInfo.permission_json_data.find(
                permission => permission.controller_id === "Operator"
            );
            if (operatorPermission && operatorPermission.read) {
                canReadOperator = true;
                this.setState({ showOperatorName: true, columns: this.getColumnsData(true) });
            }
            
        }

        // 会社選択肢セット（OEM以上）
        if (this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.oem)) {
            try {
                const res = await this.getCommonCompanySelect(this.reactContainerPath);
                this.setState({ companySelect: res.data });
            } catch (err) {
                this.showErrorObjectMesssage(err);
            }
        }

        // 会社スコープ以下のユーザーは会社が固定のため、初期表示時にスクリプト・外線・内線を取得
        if (!this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.oem)) {
            const company_id = this.props.userInfo.company_id;
            if (company_id) {
                this.loadScriptSelect(company_id);
                this.getAllExternal(company_id);
                this.loadExtensionNumberSelect(company_id);
                if (canReadOperator) {
                    this.getAllOperator(company_id);
                }
            }
        }

        // デフォルト値で初期検索
        this.onSearch(this.state.filtered);

        // cm99からIVR履歴の検索件数上限を取得
        try {
            const searchLimitResult = await this.ascAxios("post", `${this.reactContainerPath}/getSearchLimit`);
            if (searchLimitResult.data && searchLimitResult.data.limit) {
                this.setState({ searchLimit: searchLimitResult.data.limit });
            }
        } catch (err) {
            this.showErrorObjectMesssage(err);
        }
    }

    componentWillUnmount() {
        clearTimeout(this._updateTimer);
        cancelAnimationFrame(this._syncScrollFrame);
        this.blockScrollRefs = [];
        this.blockFooterRef = null;
        this.blockFooterTrackRef = null;
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.width !== this.props.width) {
            this.setState({ columns: this.getColumnsData() });
        }
        if (prevState.data !== this.state.data) {
            this.updateBlockScrollWidth();
        }
    }

    // IVR履歴画面専用 解像度別カラム幅定義
    // ≥1920: 1920×1080 / ≥1536: 1536×864 / ≥1440: 1440×900 / ≥1280: 1366×768 / <1280: フォールバック
    getIvrColumnWidths = () => {
        const w = this.props.width || window.innerWidth;
        if (w >= 1920) {
            return { id: 60, company: 95, smedium: 120, small: 100, UserName: 135, medium: 150, large: 170, Detail: 90, blockContent: 200 };
        } else if (w >= 1536) {
            return { id: 50, company: 85, smedium: 105, small: 85,  UserName: 115, medium: 130, large: 145, Detail: 80, blockContent: 165 };
        } else if (w >= 1440) {
            return { id: 45, company: 80, smedium: 95,  small: 80,  UserName: 105, medium: 120, large: 135, Detail: 75, blockContent: 155 };
        } else if (w >= 1280) {
            return { id: 45, company: 75, smedium: 75,  small: 70,  UserName: 85,  medium: 95,  large: 115, Detail: 60, blockContent: 120 };
        } else {
            return { id: 40, company: 70, smedium: 70,  small: 65,  UserName: 80,  medium: 85,  large: 105, Detail: 55, blockContent: 100 };
        }
    }

    updateBlockScrollWidth = () => {
        if (this._updateTimer) clearTimeout(this._updateTimer);
        this._updateTimer = setTimeout(() => {
            const maxW = this.blockScrollRefs
                .filter(el => el && document.body.contains(el) && el !== this.blockFooterRef)
                .reduce((max, el) => Math.max(max, el.scrollWidth), 0);
            if (this.blockFooterTrackRef && maxW > 0) {
                this.blockFooterTrackRef.style.width = maxW + "px";
            }
        }, 0);
    }

    toggleBlocking() {
        this.setState({ blocking: !this.state.blocking });
    }

    secToTime = (secs) => {
        let hour = Math.floor(secs / 3600),
            minutes = Math.floor(secs / 60) % 60,
            sec = secs % 60;

        return `${hour.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${sec.toString().padStart(2, "0")}`;
    }

    getColumnsData(showOperatorName = (this.state && this.state.showOperatorName)) {
        const cw = this.getIvrColumnWidths();
        let columns = [];

        // ID
        columns.push({
            Header: this.props.langText.Body.Id,
            accessor: "id",
            sortable: false,
            width: cw.id,
            fixed: "left",
        });

        // 会社名（OEM以上）
        if (this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.oem)) {
            columns.push({
                Header: this.props.langText.Body.CompanyName,
                accessor: "company_name",
                sortable: false,
                width: cw.company,
                style: { textAlign: "left" },
                fixed: "left",
            });
        }

        const emptyCell = "---";

        // 内線番号
        columns.push({
            Header: this.props.langText.Body.ExtensionNumber,
            accessor: "extension_number",
            sortable: false,
            width: cw.small,
            style: { textAlign: "center" },
            fixed: "left",
            Cell: data => data.value || emptyCell,
        });

        // オペレーター名（OP権限がある場合）
        if (showOperatorName) {
            columns.push({
                Header: this.props.langText.Body.OperatorName,
                accessor: "operator_name",
                sortable: false,
                width: cw.UserName,
                style: { textAlign: "left" },
                fixed: "left",
                Cell: data => data.value || emptyCell,
            });
        }

        // 外線番号
        columns.push({
            Header: this.props.langText.Body.ExternalNumber,
            accessor: "display_number",
            sortable: false,
            width: cw.smedium,
            style: { textAlign: "left" },
            fixed: "left",
            Cell: data => {
                if (data.value && data.original.external_number_memo && data.original.external_number_memo.replace(/ /g, "") !== "") {
                    return data.value + "(" + data.original.external_number_memo + ")";
                }
                return data.value || emptyCell;
            }
        });

        // 相手先番号
        columns.push({
            Header: this.props.langText.Body.DestUserNumber,
            accessor: "dest_tel_no",
            sortable: false,
            width: cw.smedium,
            style: { textAlign: "left" },
            fixed: "left",
            Cell: data => data.value || emptyCell,
        });

        // スクリプト名
        columns.push({
            Header: this.props.langText.Body.ScriptName,
            accessor: "script_name",
            sortable: false,
            width: cw.medium,
            style: { textAlign: "left" },
            fixed: "left",
            Cell: data => data.value || emptyCell,
        });

        // バージョン
        columns.push({
            Header: this.props.langText.Body.IvrHistoryVer,
            accessor: "version",
            sortable: false,
            width: 50,
            fixed: "left",
            Cell: data => data.value || emptyCell,
        });

        // 開始時間
        columns.push({
            Header: this.props.langText.Body.StartTime,
            accessor: "start_datetime",
            sortable: false,
            width: cw.large,
            style: { textAlign: "left" },
            fixed: "left",
            Cell: data => {
                return data.value ? this.getMomentTime({date: data.value, format: "YYYY/MM/DD HH:mm:ss"}) : emptyCell;
            }
        });

        // 通話時間（秒）
        columns.push({
            Header: this.props.langText.Body.TalkingTime,
            accessor: "billsec",
            sortable: false,
            width: cw.small,
            fixed: "left",
            Cell: data => {
                return data.value ? this.secToTime(data.value || 0) : emptyCell;
            }
        });

        // 結果
        columns.push({
            Header: this.props.langText.Body.Result,
            accessor: "disposition",
            sortable: false,
            width: cw.small,
            fixed: "left",
            Cell: data => data.value || emptyCell,
        });

        // ブロック内容
        columns.push({
            Header: () => {
                const isAll = this.state.blockViewMode === "all";
                const headerLabel = isAll
                    ? this.props.langText.Body.IvrHistoryBlockAllLabel
                    : this.props.langText.Body.IvrHistoryBlockLastLabel;
                const tooltipText = isAll
                    ? this.props.langText.Body.IvrHistoryBlockToggleToLastTip
                    : this.props.langText.Body.IvrHistoryBlockToggleToAllTip;
                return (
                    <div
                        ref={this.addBlockScrollRef}
                        onScroll={e => this.syncBlockScroll(e.target)}
                        className="ivr-block-content-header-scroll"
                    >
                        <span>{headerLabel}</span>
                        <OverlayTrigger
                            placement="bottom"
                            overlay={
                                <Tooltip id="block-view-toggle-tooltip" className="ivr-block-toggle-tooltip">
                                    {tooltipText}
                                </Tooltip>
                            }
                        >
                            <button
                                className="ivr-toggle-btn"
                                onClick={() => this.setState({ blockViewMode: isAll ? "last" : "all" })}
                            >
                                {this.props.langText.Body.IvrHistoryBlockToggle}
                            </button>
                        </OverlayTrigger>
                    </div>
                );
            },
            Footer: () => (
                <div
                    ref={this.setBlockFooterRef}
                    onScroll={e => this.syncBlockScroll(e.target)}
                    className="ivr-block-content-footer-scroll"
                >
                    <div
                        ref={el => { this.blockFooterTrackRef = el; }}
                        className="ivr-block-content-footer-track"
                    />
                </div>
            ),
            headerClassName: "ivr-block-content-header",
            className: "ivr-block-content-td",
            accessor: "block_content",
            sortable: false,
            minWidth: cw.blockContent,
            style: { textAlign: "left" },
            Cell: data => {
                const text = this.state.blockViewMode === "last"
                    ? (data.original.last_block_content || "")
                    : (data.value || "");
                return (
                    <div
                        ref={this.addBlockScrollRef}
                        onScroll={e => this.syncBlockScroll(e.target)}
                        className="ivr-block-content-scroll"
                    >
                        <span>{text}</span>
                    </div>
                );
            }
        });

        // 詳細
        columns.push({
            Header: this.props.langText.Body.IvrHistoryDetail,
            accessor: "detail",
            sortable: false,
            width: cw.Detail,
            fixed: "right",
            Cell: data => {
                return (
                    <Row className="text-center">
                        <Button
                            bsSize="xsmall"
                            className="control-button"
                            onClick={() => this.modalShow("ivrHistoryDetail", data)}
                        >
                            <Glyphicon glyph="search" />
                        </Button>
                    </Row>
                );
            }
        });

        return columns;
    }

    modalShow = (modalType, param) => {
        let selectedRow = param.original || param;
        this.setState({
            show: true,
            modalType: modalType,
            selectedRow: selectedRow,
        });
    }

    //検索期間未選択時、検索できないようにする
    getValidationCheck = () =>{
        let message = "";
        if (!this.getFilterData("start_datetime") || !this.getFilterData("end_datetime")){
            message = this.props.langText.Message.CallAnalysis_FindDataError;
            this.setState({searchValidation : true, message});
        } else if(moment.duration(moment(this.getFilterData("end_datetime")).diff(moment(this.getFilterData("start_datetime")))).asDays()<0){
            message = this.props.langText.Message.CallHistory_DayTermError;
            this.setState({searchValidation : true, message});
        } else if (!this.setTimeCheck(
            this.getFilterData("start_datetime"),
            this.getFilterData("end_datetime"),
            this.getFilterData("start_ji").value,
            this.getFilterData("start_hun").value,
            this.getFilterData("end_ji").value,
            this.getFilterData("end_hun").value
        )) {
            message = this.props.langText.Message.StartDateTimeCheckError;
            this.setState({searchValidation : true, message});
        } else {
            this.setState({searchValidation: false, message: ""});
        }
    }

    getDateValidationCheck = () => {
        let flag = true;
        let {
            start_datetime,
            start_hun,
            start_ji,
            end_datetime,
            end_hun,
            end_ji
        } = this.state;

        if (!start_datetime || !end_datetime){
            flag = false;
        } else if(moment.duration(moment(end_datetime).diff(moment(start_datetime))).asDays()<0){
            flag = false;
        } else if (!this.setTimeCheck(
            start_datetime,
            end_datetime,
            start_ji.value,
            start_hun.value,
            end_ji.value,
            end_hun.value
        )) {
            flag = false;
        }

        return flag;
    }

    validationHandler = (param) => {
        let nowState = null;

        switch (param) {
            case "date":
                nowState = this.getDateValidationCheck();
                break;
            default:
                break;
            }

        return nowState;
    }

    syncBlockScroll = (sourceEl) => {
        if (this._syncScrollFrame) return;
        this._syncScrollFrame = requestAnimationFrame(() => {
            this._syncScrollFrame = null;
            const scrollLeft = sourceEl.scrollLeft;
            this.blockScrollRefs = this.blockScrollRefs.filter(el => el && document.body.contains(el));
            this.blockScrollRefs.forEach(el => {
                if (el !== sourceEl) {
                    el.scrollLeft = scrollLeft;
                }
            });
        });
    }

    addBlockScrollRef = (el) => {
        if (el && !this.blockScrollRefs.includes(el)) {
            this.blockScrollRefs.push(el);
        }
    }

    setTimeCheck = (start_datetime, end_datetime, start_ji, start_hun, end_ji, end_hun) => {
        let flag = true;

        if(start_datetime && end_datetime && start_datetime.format("YYYYMMDD") === end_datetime.format("YYYYMMDD")){
            if (start_ji > end_ji) {
                flag = false;
            } else if (start_ji === end_ji && (start_hun > end_hun)) {
                flag = false;
            }
        }
        
        return flag;
    }

    setBlockFooterRef = (el) => {
        this.blockFooterRef = el;
        this.addBlockScrollRef(el);
    }

    getFilterData = (param) => {
        let my_param_data = this.state.filtered.find(row => row.id === param);
        return my_param_data ? my_param_data.value : "";
    }

    onChange = (event, param) => {
        let my_filtered = this.state.filtered;
        let target_index = my_filtered.findIndex(row => row.id === param);
        let value = "";

        if (event) {
            value = event.target ? event.target.value : event;
        }

        // script_version_toggle はチェックリストのトグル操作
        if (param === "script_version_toggle") {
            let currentVersions = this.getFilterData("script_versions") || [];
            let toggled = event; // {value, label}
            let exists = currentVersions.some(v => v.value === toggled.value);
            let newVersions = [...currentVersions];

            if (exists) {
                // バージョン解除: 解除バージョンのブロック設定のみクリア
                newVersions = newVersions.filter(v => v.value !== toggled.value);

                const removedPrefix = `block_${toggled.value}_`;
                my_filtered = my_filtered.filter(row => !row.id.startsWith(removedPrefix));

                let remainingBlockData = { ...this.state.scriptBlockData };
                delete remainingBlockData[toggled.value];

                let remainingTypes = new Set();
                Object.values(remainingBlockData).forEach(blocks => {
                    blocks.forEach(block => remainingTypes.add(block.type));
                });

                // 存在しなくなる種別はブロック種別フィルタからも除去
                let newBlockTypes = (this.state.block_type || []).filter(bt => remainingTypes.has(bt.value));
                let newBlockTypeSelect = Array.from(remainingTypes).map(type => ({
                    value: type,
                    label: this.getBlockTypeLabel(type)
                }));

                let newEnabledBlocks = { ...this.state.enabledBlocks };
                Object.keys(newEnabledBlocks).forEach(key => {
                    if (key.startsWith(removedPrefix)) delete newEnabledBlocks[key];
                });

                let versionIndex = my_filtered.findIndex(row => row.id === "script_versions");
                if (versionIndex !== -1) my_filtered.splice(versionIndex, 1);
                if (newVersions.length > 0) {
                    my_filtered.push({ id: "script_versions", value: newVersions });
                }

                // バージョンが全解除された場合はblock_condition_type, block_search_scopeもクリア
                const allVersionsCleared = newVersions.length === 0;
                if (allVersionsCleared) {
                    my_filtered = my_filtered.filter(
                        row => row.id !== "block_condition_type" && 
                        row.id !== "block_search_scope");
                }

                this.setState({
                    filtered: my_filtered,
                    block_type: newBlockTypes,
                    scriptBlockTypeSelect: newBlockTypeSelect,
                    scriptBlockData: remainingBlockData,
                    enabledBlocks: newEnabledBlocks,
                    ...(allVersionsCleared ? { blockConditionType: "and" } : {}),
                });
            } else {
                // バージョン追加: 種別・ブロック設定は維持
                const insertAt = newVersions.findIndex(v => Number(v.label) < Number(toggled.label));
                if (insertAt === -1) {
                    newVersions.push(toggled);
                } else {
                    newVersions.splice(insertAt, 0, toggled);
                }

                let versionIndex = my_filtered.findIndex(row => row.id === "script_versions");
                if (versionIndex !== -1) my_filtered.splice(versionIndex, 1);
                my_filtered.push({ id: "script_versions", value: newVersions });

                this.setState({ filtered: my_filtered }, () => {
                    this.loadAndMergeBlockDataForVersions([toggled]);
                });
            }
            return;
        }

        // script_version_all は全バージョン選択/解除のトグル
        if (param === "script_version_all") {
            let allVersions = event || [];
            let currentVersions = this.getFilterData("script_versions") || [];
            let isAllSelected = allVersions.length > 0 &&
                allVersions.every(v => currentVersions.some(cv => cv.value === v.value));

            if (isAllSelected) {
                // 全解除: すべてクリア
                let versionIndex = my_filtered.findIndex(row => row.id === "script_versions");
                if (versionIndex !== -1) my_filtered.splice(versionIndex, 1);
                my_filtered = my_filtered.filter(row =>
                    row.id !== "block_type" &&
                    row.id !== "block_condition_type" &&
                    row.id !== "block_search_scope" &&
                    !row.id.startsWith("block_")
                );

                this.setState({
                    filtered: my_filtered,
                    block_type: [],
                    scriptBlockTypeSelect: [],
                    scriptBlockData: {},
                    enabledBlocks: {},
                    blockConditionType: "and",
                    blockSearchScope: "all",
                });
            } else {
                // 全選択: 新たに追加されるバージョンのデータをマージ
                let newVersions = allVersions;
                let addedVersions = allVersions.filter(v =>
                    !currentVersions.some(cv => cv.value === v.value)
                );

                let versionIndex = my_filtered.findIndex(row => row.id === "script_versions");
                if (versionIndex !== -1) my_filtered.splice(versionIndex, 1);
                my_filtered.push({ id: "script_versions", value: newVersions });

                this.setState({ filtered: my_filtered }, () => {
                    if (addedVersions.length > 0) {
                        this.loadAndMergeBlockDataForVersions(addedVersions);
                    }
                });
            }
            return;
        }

        if (target_index !== -1) {
            my_filtered.splice(target_index, 1);
        }

        if (param === "cm12_id" && event && event.value) {
            this.getAllExternal(event.value);
            this.loadExtensionNumberSelect(event.value);
            this.loadScriptSelect(event.value);
            this.getAllOperator(event.value);
            // 会社変更時は関連する選択状態をすべてリセット
            my_filtered = my_filtered.filter(row =>
                row.id !== "display_number" &&
                row.id !== "extension_number" &&
                row.id !== "script_name" &&
                row.id !== "script_versions" &&
                row.id !== "block_type" &&
                row.id !== "block_condition_type" &&
                row.id !== "block_search_scope" &&
                !row.id.startsWith("block_")
            );
            this.setState({
                display_number: [],
                extension_number: [],
                operator_name: [],
                script_name: [],
                scriptDetailOpen: false,
                scriptVersionSelect: [],
                scriptBlockTypeSelect: [],
                scriptBlockData: {},
                enabledBlocks: {},
                block_type: [],
                blockConditionType: "and",
                blockSearchScope: "all",
            });
        } else if (param === "cm12_id") {
            this.setState({
                externalArr: [],
                display_number: [],
                extensionNumberSelect: [],
                extension_number: [],
                operatorArr: [],
                operator_name: [],
                scriptSelect: [],
                script_name: [],
                scriptDetailOpen: false,
                scriptVersionSelect: [],
                scriptBlockTypeSelect: [],
                scriptBlockData: {},
                enabledBlocks: {},
                block_type: [],
                blockConditionType: "and",
                blockSearchScope: "all",
            });
        }

        if (param === "display_number" && event) {
            this.setState({ display_number: event });
        }
        if (param === "extension_number" && event) {
            this.setState({ extension_number: event });
        }
        if (param === "operator_name" && event) {
            this.setState({ operator_name: event });
        }
        if (param === "disposition" && event) {
            this.setState({ disposition: event });
        }

        // スクリプト選択変更
        if (param === "script_name") {
            let scripts = event || [];
            this.setState({ script_name: scripts });

            // スクリプト詳細関連をリセット
            my_filtered = my_filtered.filter(row =>
                row.id !== "script_versions" &&
                row.id !== "block_type" &&
                row.id !== "block_condition_type" &&
                row.id !== "block_search_scope" &&
                !row.id.startsWith("block_")
            );
            this.setState({
                scriptVersionSelect: [],
                scriptBlockTypeSelect: [],
                scriptBlockData: {},
                enabledBlocks: {},
                block_type: [],
                blockConditionType: "and",
                blockSearchScope: "all",
            });

            // 単独選択時のみバージョン一覧を取得（詳細セクションはユーザーが手動で開く）
            if (scripts.length === 1) {
                this.loadScriptVersions(scripts[0].value);
            } else {
                this.setState({ scriptDetailOpen: false });
            }
        }

        // ブロック種別変更（表示フィルターのみ、検索には影響しない）
        if (param === "block_type") {
            let blockTypes = event || [];
            let prevBlockTypes = this.state.block_type || [];

            if (prevBlockTypes.length > 0 && blockTypes.length === 0) {
                // 種別フィルタあり→全表示: ブロック設定を維持
                this.setState({ block_type: blockTypes });
            } else if (blockTypes.length > 0) {
                // 全表示→種別フィルタあり、または種別変更: 非表示になった種別のブロック設定をクリア
                let selectedTypeValues = new Set(blockTypes.map(bt => bt.value));
                let blockData = this.state.scriptBlockData || {};

                let keysToRemove = new Set();
                Object.entries(blockData).forEach(([versionId, blocks]) => {
                    blocks.forEach(block => {
                        if (!selectedTypeValues.has(block.type)) {
                            keysToRemove.add(`block_${versionId}_${block.id}`);
                        }
                    });
                });

                my_filtered = my_filtered.filter(row => !keysToRemove.has(row.id));

                let newEnabledBlocks = { ...this.state.enabledBlocks };
                keysToRemove.forEach(key => { delete newEnabledBlocks[key]; });

                this.setState({ block_type: blockTypes, filtered: my_filtered, enabledBlocks: newEnabledBlocks });
            } else {
                // 0→0: 変化なし
                this.setState({ block_type: blockTypes });
            }
            return;
        }

        // ブロック検索条件タイプ（and/or）
        if (param === "block_condition_type") {
            let condType = event || "and";
            let idx = my_filtered.findIndex(row => row.id === "block_condition_type");
            if (idx !== -1) my_filtered.splice(idx, 1);
            my_filtered.push({ id: "block_condition_type", value: condType });
            this.setState({ blockConditionType: condType, filtered: my_filtered });
            return;
        }

        // ブロック検索スコープ（all/last）
        if (param === "block_search_scope") {
            let scope = event || "all";
            my_filtered = my_filtered.filter(row =>
                row.id !== "block_condition_type" &&
                row.id !== "block_search_scope"
            );
            my_filtered.push({ id: "block_search_scope", value: scope });
            this.setState({
                blockSearchScope: scope,
                blockConditionType: "and",
                filtered: my_filtered
            });
            return;
        }

        // 質問/番号入力ブロック：チェックONのみ（値未設定）でも存在条件で検索対象に含める
        if (param.endsWith("__enabled__")) {
            let realKey = param.replace("__enabled__", "");
            let enabledBlocks = { ...(this.state.enabledBlocks || {}) };
            enabledBlocks[realKey] = true;
            my_filtered = my_filtered.filter(row => row.id !== realKey);
            my_filtered.push({ id: realKey, value: "__exists__" });
            this.setState({ filtered: my_filtered, enabledBlocks });
            return;
        }

        // ブロック設定の値クリア（チェックOFF）
        if (param.startsWith("block_") && (value === "" || value === null || value === undefined)) {
            let enabledBlocks = { ...(this.state.enabledBlocks || {}) };
            delete enabledBlocks[param];
            my_filtered = my_filtered.filter(row => row.id !== param);
            this.setState({ filtered: my_filtered, enabledBlocks });
            return;
        }

        // バージョン別ブロック全選択/解除
        if (param === "block_version_all") {
            let { versionId, blocks, check } = event;
            let enabledBlocks = { ...(this.state.enabledBlocks || {}) };
            let newFiltered = my_filtered.filter(row => !row.id.startsWith("block_" + versionId + "_"));
            if (check) {
                blocks.forEach(block => {
                    let blockKey = "block_" + versionId + "_" + block.id;
                    let bType = Number(block.type);
                    let isCheckable = bType === CallType.QUESTION || bType === CallType.NUMBER;
                    if (isCheckable) {
                        enabledBlocks[blockKey] = true;
                    }
                    newFiltered.push({ id: blockKey, value: "__exists__" });
                });
            } else {
                blocks.forEach(block => {
                    let blockKey = "block_" + versionId + "_" + block.id;
                    delete enabledBlocks[blockKey];
                });
            }
            this.setState({ filtered: newFiltered, enabledBlocks });
            return;
        }

        if (value && (!Array.isArray(value) || value.length)) {
            my_filtered.push({
                id: param,
                value
            });
        }

        if (param === "start_datetime" && event === null) {
            let returnValue = my_filtered.filter(row => row.id !== "start_ji" && row.id !== "start_hun");
            returnValue.push({ id: "start_ji", value: { value: "00", label: "00" } });
            returnValue.push({ id: "start_hun", value: { value: "00", label: "00" } });
            my_filtered = returnValue;
        } else if (param === "end_datetime" && event === null) {
            let returnValue = my_filtered.filter(row => row.id !== "end_ji" && row.id !== "end_hun");
            returnValue.push({ id: "end_ji", value: { value: "23", label: "23" } });
            returnValue.push({ id: "end_hun", value: { value: "59", label: "59" } });
            my_filtered = returnValue;
        }

        this.setState({ filtered: my_filtered }, () => {
            this.getValidationCheck();
        });
    }

    // スクリプト選択肢を取得
    loadScriptSelect = async (cm12_id) => {
        try {
            const result = await this.ascAxios("post", `${this.reactContainerPath}/getScriptSelect`, { cm12_id: cm12_id });
            this.setState({ scriptSelect: result.data });
        } catch (err) {
            console.error(err);
        }
    }

    // スクリプトのバージョン一覧を取得
    loadScriptVersions = async (cm70_id) => {
        try {
            const result = await this.ascAxios("post", "/Script/getVersionList", { cm70_id: cm70_id });
            let versions = (result.data.versionList || []).map(row => ({
                value: row.id,
                label: String(row.version)
            }));

            // バージョン選択はデフォルトOFF（ユーザーが手動で選択）
            let my_filtered = [...this.state.filtered];
            let versionIndex = my_filtered.findIndex(row => row.id === "script_versions");
            if (versionIndex !== -1) my_filtered.splice(versionIndex, 1);
            my_filtered = my_filtered.filter(row =>
                row.id !== "block_type" && !row.id.startsWith("block_")
            );
            this.setState({
                scriptVersionSelect: versions,
                filtered: my_filtered,
                block_type: [],
                scriptBlockTypeSelect: [],
                scriptBlockData: {},
            });
        } catch (err) {
            console.error(err);
        }
    }

    // 選択バージョンのブロックデータを一括取得
    loadBlockDataForVersions = async (selectedVersions) => {
        let results = await Promise.all(selectedVersions.map(async ver => {
            try {
                const result = await this.ascAxios("post", `${this.reactContainerPath}/getBlocksByVersionId`, { cm71_id: ver.value });
                return { versionId: ver.value, blocks: result.data || [] };
            } catch (err) {
                console.error(err);
                return { versionId: ver.value, blocks: [] };
            }
        }));

        let blockData = {};
        let allBlockTypes = new Set();

        results.forEach(({ versionId, blocks }) => {
            blockData[versionId] = blocks;
            blocks.forEach(block => {
                allBlockTypes.add(block.type);
            });
        });

        // ブロック種別の選択肢を構築
        let blockTypeOptions = Array.from(allBlockTypes).map(type => ({
            value: type,
            label: this.getBlockTypeLabel(type)
        }));

        this.setState({
            scriptBlockData: blockData,
            scriptBlockTypeSelect: blockTypeOptions,
        });
    }

    // バージョン追加時: 既存ブロックデータを保持しつつ指定バージョンのデータをマージ
    loadAndMergeBlockDataForVersions = async (versionsToLoad) => {
        let results = await Promise.all(versionsToLoad.map(async ver => {
            try {
                const result = await this.ascAxios("post", `${this.reactContainerPath}/getBlocksByVersionId`, { cm71_id: ver.value });
                return { versionId: ver.value, blocks: result.data || [] };
            } catch (err) {
                console.error(err);
                return { versionId: ver.value, blocks: [] };
            }
        }));

        let newBlockData = { ...this.state.scriptBlockData };
        results.forEach(({ versionId, blocks }) => {
            newBlockData[versionId] = blocks;
        });

        let allBlockTypes = new Set();
        Object.values(newBlockData).forEach(vBlocks => {
            vBlocks.forEach(block => allBlockTypes.add(block.type));
        });

        let blockTypeOptions = Array.from(allBlockTypes).map(type => ({
            value: type,
            label: this.getBlockTypeLabel(type)
        }));

        this.setState({
            scriptBlockData: newBlockData,
            scriptBlockTypeSelect: blockTypeOptions,
        });
    }

    // ブロックタイプ値から表示名を取得
    getBlockTypeLabel = (type) => {
        let langText = this.props.langText;
        switch (type) {
            case CallType.START: return langText.Body.ScriptStart;
            case CallType.PLAY: return langText.Body.ScriptPlay;
            case CallType.QUESTION: return langText.Body.ScriptQuestion;
            case CallType.NUMBER: return langText.Body.ScriptNumberInput;
            case CallType.TRANSFER: return langText.Body.ScriptTransfer;
            case CallType.RECORD: return langText.Body.ScriptRecord;
            case CallType.COUNT: return langText.Body.ScriptCount;
            case CallType.JUMP: return langText.Body.ScriptJump;
            case CallType.SMS: return langText.Body.ScriptSMS;
            case CallType.INCOMING: return langText.Body.ScriptIncoming;
            default: return String(type);
        }
    }

    // スクリプト詳細セクションの開閉トグル
    toggleScriptDetail = () => {
        this.setState({ scriptDetailOpen: !this.state.scriptDetailOpen });
    }

    getAllOperator = async (cm12_id) => {
        try {
            const result = await this.ascAxios("post", `${this.reactContainerPath}/getAllOperator`, { cm12_id });
            const additionalOption = { value: "", label: this.props.langText.Body.OperatorNull };
            result.data.unshift(additionalOption);
            this.setState({ operatorArr: result.data });
        } catch (err) {
            console.error(err);
        }
    }

    getAllExternal = async (cm12_id) => {
        try {
            const result = await this.ascAxios("post", `${this.reactContainerPath}/getallExternal`, { cm12_id: cm12_id });
            this.setState({ externalArr: result.data });
        } catch (err) {
            console.error(err);
        }
    }

    loadExtensionNumberSelect = async (company_id) => {
        try {
            const result = await this.ascAxios("post", `${this.reactContainerPath}/getExtensionNumberSelect`, { company_id: company_id });
            this.setState({ extensionNumberSelect: result.data });
        } catch (err) {
            console.error(err);
        }
    }

    onSearch = async (filter) => {
        try {
            this.setState({ loading: true });

            const searchState = {
                page: 0,
                pageSize: this.state.pageSize || 20,
                sorted: [{ id: "start_datetime", desc: true }]
            };

            await this.execSearch(filter, searchState);

            this.setState({ hidden_filtered: [...filter] });
        } catch (err) {
            console.error(err);
            this.showErrorObjectMesssage(err, "DataSelectError");
        }
    }

    execSearch = async (filter, state = null) => {
        try {
            this.setState({ loading: true });

            // ページング指定の妥当性を確認し、不正値のときは既定値へフォールバックする
            const page = typeof (state && state.page) === "number" ? state.page : this.state.page;
            const pageSize = Number(state && state.pageSize);
            const safePageSize = Number.isFinite(pageSize) && pageSize > 0 ? pageSize : (this.state.pageSize || 20);

            const searchParams = {
                filtered: filter,
                sorted: state && state.sorted && state.sorted.length > 0 ? state.sorted[0] : {},
                showOperatorName: this.state.showOperatorName,
                page,
                pageSize: safePageSize
            };

            const result = await this.ascAxios("post", `${this.reactContainerPath}/board`, searchParams);

            const formattedData = this.formatForTableDisplay(result.data.data, this.state.block_type);

            const summary = result.data.summary || {};
            // 検索件数超過チェック
            if (result.data.code === "IvrHistorySearchLimit") {
                const count = result.data.count || 0;
                const limit = result.data.limit || this.state.searchLimit;
                this.setState({
                    data: [],
                    count: 0,
                    pages: null,
                    loading: false,
                });
                return this.showErrorObjectMesssage({
                    message: "IvrHistoryTooManyResults",
                    args: [count.toLocaleString(), limit.toLocaleString()]
                });
            }

            this.setState({
                data: formattedData,
                count: result.data.count,
                pages: result.data.pages,
                page: searchParams.page,
                pageSize: searchParams.pageSize,
                loading: false,
                summaryTotalCalls: summary.totalCalls != null ? summary.totalCalls.toLocaleString() : null,
                summaryAnsweredCalls: summary.answeredCalls != null ? summary.answeredCalls.toLocaleString() : null,
                summaryMissedCalls: summary.missedCalls != null ? summary.missedCalls.toLocaleString() : null,
                summaryAnswerRate: summary.answerRate != null ? summary.answerRate + "%" : null,
                summaryIncomingBlockPassCount: summary.incomingBlockPassCount != null ? summary.incomingBlockPassCount.toLocaleString() : null,
                summaryNoAnswerCount: summary.noAnswerCount != null ? summary.noAnswerCount.toLocaleString() : null,
                summaryIncomingBlockAnsweredCount: summary.incomingBlockAnsweredCount != null ? summary.incomingBlockAnsweredCount.toLocaleString() : null,
            });
        } catch (err) {
            console.error(err);
            this.setState({
                data: [],
                pages: null,
                count: null,
                loading: false,
                summaryTotalCalls: null,
                summaryAnsweredCalls: null,
                summaryMissedCalls: null,
                summaryAnswerRate: null,
                summaryIncomingBlockPassCount: null,
                summaryNoAnswerCount: null,
                summaryIncomingBlockAnsweredCount: null,
            });
            this.showErrorObjectMesssage(err, "DataSelectError");
        }
    }

    formatForTableDisplay = (hits, blockTypeFilter = []) => {
        // 応答形式チェック: 想定配列でなければ空データとして扱う
        if (!hits || !Array.isArray(hits)) return [];

        return hits.map(hit => {
            const source = hit._source || {};
            let blockContent = "";
            if (source.blocks && Array.isArray(source.blocks)) {
                let blocks = source.blocks;
                // ブロック内容は種別フィルターに関わらず全ブロックを表示する
                blockContent = blocks.map(b => {
                    let label = b.title || "";
                    let bType = Number(b.type);
                    // 結果値の有無を共通判定（null / 空文字 / "null" は未入力扱い）
                    let hasResult = b.result != null && b.result !== "" && b.result !== "null";
                    // 質問と番号入力ブロックは結果を表示
                    if (bType === CallType.QUESTION) {
                        label += ":" + (hasResult ? b.result : this.props.langText.Body.IvrHistoryOther);
                    } else if (bType === CallType.NUMBER) {
                        label += ":" + (hasResult ? b.result : this.props.langText.Body.IvrHistoryNoInput);
                    } 
                    return label;
                }).filter(s => s).join(" > ");
            }

            // 最終ブロック内容を計算
            let lastBlockContent = "";
            if (source.blocks && Array.isArray(source.blocks) && source.blocks.length > 0) {
                const lastBlock = source.blocks[source.blocks.length - 1];
                let lastLabel = lastBlock.title || "";
                let lastBType = Number(lastBlock.type);
                let lastHasResult = lastBlock.result != null
                    && lastBlock.result !== ""
                    && lastBlock.result !== "null";
                if (lastBType === CallType.QUESTION) {
                    lastLabel += ":" + (lastHasResult ? lastBlock.result : this.props.langText.Body.IvrHistoryOther);
                } else if (lastBType === CallType.NUMBER) {
                    lastLabel += ":" + (lastHasResult ? lastBlock.result : this.props.langText.Body.IvrHistoryNoInput);
                }
                lastBlockContent = lastLabel;
            }

            return {
                id: hit._id,
                ct60_id: source.ct60_id,
                cm12_id: source.cm12_id,
                company_name: source.company_name || "",
                extension_number: source.extension_number,
                operator_name: source.operator_name || "",
                display_number: source.display_number,
                external_number_memo: source.external_number_memo || "",
                dest_tel_no: source.dest_tel_no,
                script_name: source.script_name || "",
                version: source.version,
                start_datetime: source.start_datetime,
                billsec: source.billsec,
                disposition: source.disposition,
                block_content: blockContent,
                last_block_content: lastBlockContent,
                blocks: source.blocks,
            };
        });
    }

    clearSearchCondition = () => {
        // OEM以上は会社選択肢・外線・内線・スクリプト選択肢もリセット
        // OEM未満は会社固定のため選択肢はそのまま保持
        const isOemOrAbove = this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.oem);
        const clearSelectState = isOemOrAbove
            ? {
                externalArr: [],
                extensionNumberSelect: [],
                scriptSelect: [],
            }
            : {};

        this.setState({
            filtered: [
                {
                    id: "start_datetime",
                    value: moment({h: 0, m: 0, s: 0, ms: 0})
                },
                {
                    id: "end_datetime",
                    value: moment({h: 0, m: 0, s: 0, ms: 0})
                },
                {
                    id: "start_ji",
                    value: { value: "00", label: "00" },
                },
                {
                    id: "start_hun",
                    value: { value: "00", label: "00" },
                },
                {
                    id: "end_ji",
                    value: { value: "23", label: "23" },
                },
                {
                    id: "end_hun",
                    value: { value: "59", label: "59" },
                },
            ],
            display_number: [],
            extension_number: [],
            operator_name: [],
            disposition: [],
            script_name: [],
            block_type: [],
            blockConditionType: "and",
            blockSearchScope: "all",
            scriptDetailOpen: false,
            scriptVersionSelect: [],
            scriptBlockTypeSelect: [],
            scriptBlockData: {},
            enabledBlocks: {},
            ...clearSelectState,
        }, () => {
            this.getValidationCheck();
        });
    }

    menuHandle = () => {
        this.setState({
            menu_flag: !this.state.menu_flag,
            menu_width: this.state.menu_flag ? 0 : 400,
        });
    }

    getCsvFileName() {
        let hiddenStartDatetime = this.state.hidden_filtered.find(row => row.id === "start_datetime");
        let date = hiddenStartDatetime ? hiddenStartDatetime.value : "";
        let file_name = "";
        if (!!date) {
            file_name = moment(date).format("YYYYMMDD") + "_";
        }
        let nowTime = moment().utc().add(9, 'h').format("YYYYMMDDHHmmss");
        return file_name + (this.props.langText.Body.IvrHistory) + "_" + nowTime + ".csv";
    }

    moldCsvHeader() {
        const bodyLang = this.props.langText.Body;
        const headers = [
            { label: bodyLang.Id, key: "id" },
            { label: bodyLang.CallHistoryId, key: "call_history_id" },
            { label: bodyLang.CompanyName, key: "company_name" },
            { label: bodyLang.DepartmentName, key: "department_name" },
        ];

        if (this.props.userInfo && this.props.userInfo.floor_flg) {
            headers.push({ label: bodyLang.FloorName, key: "floor_name" });
        }

        headers.push({ label: bodyLang.ExtensionNumber, key: "extension_number" });

        if (this.state.showOperatorName) {
            headers.push({ label: bodyLang.OperatorName, key: "operator_name" });
        }

        headers.push(
            { label: bodyLang.ExternalNumber, key: "display_number" },
            { label: bodyLang.ExternalNumberMemo, key: "external_number_memo" },
            { label: bodyLang.DestUserNumber, key: "dest_tel_no" },
            { label: bodyLang.CustomerName, key: "customer_name" },
            { label: bodyLang.ScriptName, key: "script_name" },
            { label: bodyLang.IvrHistoryVer, key: "version" },
            { label: bodyLang.StartTime, key: "start_datetime" },
            { label: bodyLang.BillSec, key: "billsec" },
            { label: bodyLang.Result, key: "disposition" },
            { label: bodyLang.IvrHistoryBlockAll, key: "block_content" },
            { label: bodyLang.IvrHistoryBlockLast, key: "last_block_content" }
        );

        return headers;
    }

    ivrHistoryCsvDL = async () => {
        try {
            this.blockUI();
            const showFloor = !!(this.props.userInfo && this.props.userInfo.floor_flg);
            const requestPayload = {
                filtered: this.state.filtered,
                showFloor,
                showOperatorName: this.state.showOperatorName
            };
            const res = await this.ascAxios("post", `${this.reactContainerPath}/csvDownload`, requestPayload);

            const clientDownloadLimit = (this.props.charaLimit && this.props.charaLimit.Client_Download_Limit)
                ? this.props.charaLimit.Client_Download_Limit
                : 10000;

            if (res.data.count > clientDownloadLimit) {
                return this.showErrorObjectMesssage({ message: "IvrHistoryDownloadLimit" });
            }

            if (res.data.count > 0 || (res.data.rows && res.data.rows.length > 0)) {
                this.setState({ csvdata: res.data.rows || [] });
                return this.csvLink.current.link.click();
            }

            return this.showErrorObjectMesssage({ message: "Download_Failed" });
        } catch (err) {
            console.error(err);
            this.showErrorObjectMesssage(err, "DataSelectError");
        } finally {
            this.unblockUI();
        }
    }

    render() {
        const langText = this.props.langText;
        // 検索期間の表示用テキスト
        const hiddenStartDate = this.state.hidden_filtered.find(row => row.id === "start_datetime");
        const hiddenEndDate = this.state.hidden_filtered.find(row => row.id === "end_datetime");
        const startStr = hiddenStartDate ? moment(hiddenStartDate.value).format("YYYY/MM/DD") : "---";
        const endStr = hiddenEndDate ? moment(hiddenEndDate.value).format("YYYY/MM/DD") : "---";
        const periodText = (startStr === endStr) ? startStr : startStr + " - " + endStr;

        const summaryCards = [
            { title: langText.Body.IvrHistorySummaryTotalCalls, data: this.state.summaryTotalCalls, subdata: periodText },
            { title: langText.Body.IvrHistorySummaryAnsweredCalls, data: this.state.summaryAnsweredCalls, subdata: langText.Body.IvrHistorySummaryAnsweredCallsSub + (this.state.summaryIncomingBlockAnsweredCount || "0") + langText.Body.IvrHistorySummaryUnit },
            { title: langText.Body.IvrHistorySummaryMissedCalls, data: this.state.summaryMissedCalls, subdata: langText.Body.IvrHistorySummaryMissedCallsSub + (this.state.summaryNoAnswerCount || "0") + langText.Body.IvrHistorySummaryUnit },
            { title: langText.Body.IvrHistorySummaryAnswerRate, data: this.state.summaryAnswerRate, subdata: langText.Body.IvrHistorySummaryAnswerRateSub },
            { title: langText.Body.IvrHistorySummaryIncomingBlockPassCount, data: this.state.summaryIncomingBlockPassCount, subdata: langText.Body.IvrHistorySummaryIncomingBlockPassCountSub },
        ];
        return (
            <div>
                <BlockUi tag="div" blocking={this.state.blocking} message={this.props.langText.Body.Wait} keepInView>
                    <div className="IvrHistory">
                        <div style={{ display: "flex", gap: "10px", marginTop: "10px", marginBottom: "10px" }}>
                            {summaryCards.map((card, index) => (
                                <div key={index} className="ivr-summary-card">
                                    <div style={{ fontSize: "11px", color: "#888" }}>{card.title}</div>
                                    <div style={{ fontSize: "24px", fontWeight: "bold", margin: "4px 0", textAlign: "center" }}>{card.data || "---"}</div>
                                    <div style={{ fontSize: "11px", color: "#aaa" }}>{card.subdata}</div>
                                </div>
                            ))}
                        </div>
                        <Row>
                            <Col xs={12} md={12} className="margin-top-03 flex-style">
                                <Col sm={12} md={8} lg={6} className="search-count" style={{ display: "flex", alignItems: "center" }}>
                                    <label>{this.props.langText.Body.SearchResult}</label>
                                    <label className="result-count">{(this.state.count || 0).toLocaleString()}{this.props.langText.Body.Count}</label>
                                    <CSVLink
                                        data={this.state.csvdata}
                                        headers={this.moldCsvHeader()}
                                        filename={this.getCsvFileName()}
                                        className="hidden"
                                        ref={this.csvLink}
                                    />
                                    {this.props.currentPermission.export && (
                                    <span style={{ marginLeft: "16px" }}>
                                    <Button
                                        id="ivr-history-download"
                                        className="table-button"
                                        bsStyle="default"
                                        bsSize="sm"
                                        onClick={this.ivrHistoryCsvDL}
                                        disabled={this.state.hidden_filtered.length === 0 || this.state.loading}
                                    >
                                        {this.props.langText.Body.IvrHistoryDownload}
                                    </Button>
                                    </span>
                                    )}
                                </Col>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={12} className="margin-top-05">
                                <ColumnFixTable
                                    talbeRef={this.table}
                                    className="IvrHistoryTable"
                                    style={{ height: this.props.tableHeight }}
                                    manual="manual"
                                    columns={this.state.columns}
                                    data={this.state.data}
                                    pages={this.state.pages}
                                    page={this.state.page}
                                    pageSize={this.state.pageSize}
                                    loading={this.state.loading}
                                    defaultSorted={[{ id: "start_datetime", desc: true }]}
                                    onFetchData={async (state) => {
                                        if (this.state.hidden_filtered.length === 0) return;
                                        this.setState({
                                            page: state.page,
                                            pageSize: state.pageSize || this.state.pageSize,
                                        });
                                        await this.execSearch(
                                            this.state.hidden_filtered,
                                            state
                                        );
                                    }}
                                    hidden_filtered={this.state.hidden_filtered}
                                    previousText={this.props.langText.Table.PreviousText}
                                    nextText={this.props.langText.Table.NextText}
                                    loadingText={this.props.langText.Table.LoadingText}
                                    noDataText={this.props.langText.Table.NoDataText}
                                    rowsText={this.props.langText.Table.RowsText}
                                />
                            </Col>
                        </Row>
                    </div>
                    <Col xs={0} sm={0}>
                        <div className="ivr-search-menu" style={{
                            width: this.state.menu_width,
                            height: this.state.menu_height
                        }}>
                            <div style={{ width: 400, minWidth: 400, height: "100%", overflowY: "auto" }}>
                            <IvrHistoryMenu
                                state={this.state}
                                userInfo={this.props.userInfo}
                                langText={this.props.langText}
                                getFilterData={this.getFilterData}
                                onChange={this.onChange}
                                onSearch={this.onSearch}
                                onClear={this.clearSearchCondition}
                                setToTime={this.secToTime}
                                getScopeGreaterEqual={this.getScopeGreaterEqual}
                                hourShowList={this.hourShowList}
                                minuteShowList={this.minuteShowList}
                                onToggleScriptDetail={this.toggleScriptDetail}
                                enabledBlocks={this.state.enabledBlocks}
                                operatorArr={this.state.operatorArr}
                                getBlockTypeLabel={this.getBlockTypeLabel}
                            />
                            </div>
                        </div>
                    </Col>
                    <div className="search-menu-div">
                        <Button
                            className="search-menu-button"
                            style={this.state.menu_flag ? { transform: "translateX(-400px)" } : {}}
                            onClick={() => this.menuHandle()}
                        >
                            {
                                this.state.menu_flag
                                ? this.props.langText.Body.Quotation
                                : this.props.langText.Body.LessThan
                            }
                        </Button>
                    </div>
                </BlockUi>
                {this.state.show && (
                    <IvrHistoryModal
                        state={this.state}
                        propSetState={this.propSetState}
                        langText={this.props.langText}
                        closeModal={() => this.setState({ show: false })}
                        getScopeGreaterEqual={this.getScopeGreaterEqual}
                        GlobalConst={GlobalConst}
                        getMomentTime={this.getMomentTime}
                        secToTime={this.secToTime}
                        getBlockTypeLabel={this.getBlockTypeLabel}
                    />
                )}
            </div>
        );
    }
}



